/**
 * Keep this file tiny: heavy sync imports (App → global SCSS, etc.) live in `bootstrap.js`.
 * That way the landing chunk `import()` runs as soon as this module evaluates, instead of
 * after several seconds of main-thread parse on large bundles.
 */
void import(/* webpackPreload: true */ "./screens/landing/index");

import("./bootstrap");
